export default {
  payment_methods: {
    card: 'Kredit-/ Debit Karte',
    sofort: 'Sofort',
    giropay: 'Giropay',
    iban: 'EC-Karte / IBAN',
    cash: 'Barzahlung',
  },
};
